'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _projects = require('helpers/projects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectItemActions = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ProjectItemActions, _PureComponent);

  function ProjectItemActions() {
    (0, _classCallCheck3.default)(this, ProjectItemActions);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectItemActions.__proto__ || (0, _getPrototypeOf2.default)(ProjectItemActions)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectItemActions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          project = _props.project,
          onCreateSubproject = _props.onCreateSubproject,
          onEdit = _props.onEdit,
          onReport = _props.onReport,
          onDelete = _props.onDelete,
          userPermissions = _props.userPermissions;
      var t = this.context.t;

      var _getProjectPermission = (0, _projects.getProjectPermissions)({ project: project, userPermissions: userPermissions }),
          canDelete = _getProjectPermission.canDelete,
          canEdit = _getProjectPermission.canEdit,
          canGetReport = _getProjectPermission.canGetReport,
          canCreateSubproject = _getProjectPermission.canCreateSubproject;

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(className) },
        canCreateSubproject && _react2.default.createElement(
          'a',
          { onClick: onCreateSubproject },
          t('Create project')
        ),
        canEdit && _react2.default.createElement(
          'a',
          { onClick: onEdit },
          t('Edit')
        ),
        canGetReport && _react2.default.createElement(
          'a',
          { onClick: onReport },
          t('Report')
        ),
        canDelete && _react2.default.createElement(
          'a',
          { onClick: onDelete },
          t('Delete')
        )
      );
    }
  }]);
  return ProjectItemActions;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  onCreateSubproject: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onEdit: _propTypes2.default.func,
  onReport: _propTypes2.default.func,
  project: _propTypes2.default.object,
  userPermissions: _propTypes2.default.object
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  onCreateSubproject: _noop3.default,
  onDelete: _noop3.default,
  onEdit: _noop3.default,
  onReport: _noop3.default,
  project: {},
  userPermissions: {}
}, _temp);
exports.default = ProjectItemActions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/ProjectItemActions/ProjectItemActions.js
// module id = 2063
// module chunks = 1